import { NOOP } from '../../../../utils/const.js';
import { getRandomId } from '../../../Utils/baseComponentHelper.js';

class LoadingSession {
    constructor(term) {
        this.id = getRandomId();
        this.notifyLoaded = NOOP;
        this.notifyCompleted = NOOP;
        this.term = term;
    }
    onLoaded(callback) {
        this.notifyLoaded = callback || NOOP;
        return this;
    }
    onCompleted(callback) {
        this.notifyCompleted = callback || NOOP;
        return this;
    }
    complete() {
        this.notifyLoaded = NOOP; // evito chiamate successive al completamento
        this.notifyCompleted();
    }
    notifyLoadCompleted(item) {
        this.notifyLoaded(item);
    }
    getTerm() {
        return this.term;
    }
    equals(session) {
        return session instanceof LoadingSession && this.id === session.id;
    }
}

export { LoadingSession as default };
